import { render, staticRenderFns } from "./AppModalDialog.vue?vue&type=template&id=0795820c&"
import script from "./AppModalDialog.vue?vue&type=script&lang=js&"
export * from "./AppModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports